import React from "react";
import "../modern-widgets.scss";

const NumberInfo = ({
  title,
  iconImage,

  // First Data Point
  categoryTitle, 
  totalItems,

  // Second Data Point
  categoryTitle1,
  totalQuantity,

  // Third Data Point
  categoryTitle2,
  totalCbm,
}) => {
  const formatValue = (val) => {
    if (typeof val === 'number') return val.toLocaleString();
    if (val === null || val === undefined) return '';
    return val;
  };

  return (
    <div className="modern-widget">
      {/* Header Section */}
      {title && (
        <div className="widget-header">
          <div className="widget-title">
            {iconImage && <img src={iconImage} alt="icon" className="widget-icon" />}
            {title}
          </div>
        </div>
      )}

      {/* Body/Stats Section */}
      <div className="widget-body">
        {/* Item 1 - Usually Liability */}
        {(totalItems !== undefined && totalItems !== null && categoryTitle) && (
          <div className="stat-group">
            <div className="stat-value primary">
              {formatValue(totalItems)}
            </div>
            <div className="stat-label">{categoryTitle}</div>
          </div>
        )}

        {/* Item 2 - Usually Cancellation */}
        {(totalQuantity !== undefined && totalQuantity !== null && categoryTitle1) && (
          <div className="stat-group">
            <div className="stat-value warning">
              {formatValue(totalQuantity)}
            </div>
            <div className="stat-label">{categoryTitle1}</div>
          </div>
        )}

        {/* Item 3 */}
        {(totalCbm !== undefined && totalCbm !== null && categoryTitle2) && (
          <div className="stat-group">
            <div className="stat-value accent">
              {formatValue(totalCbm)}
            </div>
            <div className="stat-label">{categoryTitle2}</div>
          </div>
        )}
      </div>
    </div>
  );
};

export default NumberInfo;
